import { Lang } from "@/utils/lang.enum";

export class UserSummaryOutDTO {
  id!: string;
  email!: string;
  displayedName!: string;
  lang!: Lang;
}
